import "./style.sass";
import { createPortal } from "react-dom";

export const AnswerEvaluationModal = ({ onClose, data }) => {
  console.log(data, "Evaluation Response Data Source");

  // Support nested 'data' property if it exists
  const root = data?.data || data;

  // Key updates based on provided sample: 'DETAILS' is the list key
  const evaluationList = root?.DETAILS || root?.details || root?.evaluation || root?.results || (Array.isArray(root) ? root : []);
  
  // Scoring info from root
  const totalScore = root?.TOTAL_SCORE !== undefined ? root.TOTAL_SCORE : (root?.total_score || 0);
  const maxOverall = root?.MAX_SCORE || root?.max_score || 0;

  // Only show score cards if they actually have data
  const hasCategoryScores = !!(root?.content || root?.structure || root?.analysis || root?.presentation);

  const renderScoreCard = (title, scoreKey, icon, type) => {
    const scoreData = root?.[scoreKey];
    if (!scoreData) return null;

    const score = scoreData.score || "0";
    const max = scoreData.max || "0";
    const status = scoreData.status || "N/A";
    
    return (
      <section className={`score-card ${type}`}>
        <section className="card-header-row">
          <span className="card-title">{title}</span>
          <span className="card-icon">{icon}</span>
        </section>
        <section className="card-score">{score}/{max}</section>
        <section className="card-status">{status}</section>
      </section>
    );
  };

  const renderQuesAns = (item, index) => {
    const question = item?.QUESTION || item?.question || "";
    const feedback = item?.FEEDBACK || item?.feedback || "";
    const score = item?.SCORE !== undefined ? item.SCORE : (item?.score || 0);
    const maxMarks = item?.MAX_MARKS || item?.MAX_SCORE || item?.max_score || 3;
    const remark = item?.REMARK || item?.remark || "";
    const userAnswer = item?.ANSWER || item?.user_answer || "";

    return (
      <section className="review-block" key={index}>
        <section className="question-title">
          {index + 1}. {question}
        </section>
        
        <section className="feedback-row">
          <section className="score-badge">
            {score}/{maxMarks}
          </section>
          <section className="feedback-content">
            <section className="feedback-text">
              {feedback}
            </section>
            {remark && (
              <section className="remark-text">
                <strong>Remark:</strong> {remark}
              </section>
            )}
          </section>
        </section>

        {userAnswer && (
          <section className="user-answer-preview">
            <strong>Your Answer:</strong> {userAnswer}
          </section>
        )}
      </section>
    );
  };

  return createPortal(
    <section className="evaluation-overlay">
      <section className="evaluation-modal">
        {/* HEADER */}
        <section className="evaluation-header">
          <section className="header-left">
            <section className="doc-icon">📄</section>
            <section>
              <h2>Your Answer Evaluation Results</h2>
              <p>Detailed breakdown of your performance with AI-powered feedback</p>
            </section>
          </section>

          <button className="btn-close" onClick={onClose}>
            ✕
          </button>
        </section>

        {/* BODY */}
        <section className="evaluation-body">
          {/* SCORE CARDS - Only show if data exists */}
          {hasCategoryScores && (
            <section className="score-cards">
              {renderScoreCard("CONTENT", "content", "📖", "good")}
              {renderScoreCard("STRUCTURE", "structure", "🥞", "excellent")}
              {renderScoreCard("ANALYSIS", "analysis", "🔍", "fair")}
              {renderScoreCard("PRESENTATION", "presentation", "🖋️", "needs")}
            </section>
          )}

          {/* QUESTION REVIEW BLOCK */}
          <section className="questions-review-list">
            {evaluationList.length > 0 ? (
              evaluationList.map(renderQuesAns)
            ) : (
              <section className="no-data-wrapper">
                <p className="no-data">No evaluation results found in the response.</p>
                <div className="debug-hint" style={{fontSize: '10px', color: '#ccc', textAlign: 'center'}}>
                  Check console for "Evaluation Response Data Source"
                </div>
              </section>
            )}
          </section>
        </section>

        {/* FOOTER */}
        <section className="evaluation-footer">
          <section className="footer-actions">
            <button className="close-review-btn" onClick={onClose}>
              Close Review 
            </button>
          </section>
        </section>
      </section>
    </section>,
    document.getElementById("popup") || document.body
  );
};
